// page : '/obsrec/kansatsukiroku/:koujibangou' 

// react redux react-redux history moment react-router-dom
import * as React from 'react';
import { Dispatch, Action } from 'redux';
import { connect } from 'react-redux';
import * as H from 'history';
import * as moment from 'moment';
import { NavLink } from 'react-router-dom';
// material-ui
import { Typography, Paper, Button, List, ListItem, ListItemText, Grid } from '@material-ui/core';
// parts
import { CloseBackButton } from '../parts/CloseBackButton';
// utils
import { download } from '../../utils'; // todo 将来的にレコード単位のダウンロードを可能にする処理を記述する
// models
import { SiteInfo } from '../../models/SiteInfo';
// redux state
import { IAppState } from '../../redux/modules';
import { SiteInfoListObsrecState } from '../../redux/modules/siteInfoListObsrec';
import { KansatsuKirokuObsrecState } from '../../redux/modules/kansatsuKirokuObsrec';
// redux operations
import { kansatsuKirokuObsrecOperations } from '../../redux/modules';

const styles = {
  contentBase: {
    padding: '10px',
    marginBottom: '20px'
  }
};

interface OwnProps {
  match: any; // withRouterにより設定される
  sites: SiteInfoListObsrecState;
  history: H.History;
  clear: () => void;
  fetch: ({koujiBangou}: {koujiBangou:string}) => any;
  kansatsuKirokuObsrec: KansatsuKirokuObsrecState;
}

interface OwnState {
  // 工事現場の情報
  site: SiteInfo | undefined;
};

class KansatuKirokuObsrecListPage extends React.Component<OwnProps, OwnState>{
  constructor(props: OwnProps) {
    super(props);
    this.state = {
      site: undefined
    };
  }
  componentDidMount() {
    // このページの工事番号
    const koujiBangou = this.props.match.params.koujibangou;
    // このページの工事情報
    const siteInfo = this.props.sites.items.find((item) => (item.koujiBangou === koujiBangou));
    // 工事情報が不正な場合はリストに戻る
    if (!siteInfo) {
      this.props.history.replace('/Obsrec/sitelist');
      return ;
    }
    this.setState({ site: siteInfo });

    // 検索
    this.props.fetch({ koujiBangou });

  }

  render() {
    const site = this.state.site || new SiteInfo();
    return (
    <div>
      <Paper style={{ padding: '10px' }}>
        <Typography variant="h4" style={{ marginBottom: '10px' }}>
          {site.koujiBangou} : {site.name}
        </Typography>
        <Paper
          style={styles.contentBase}
        >
          <Button
            variant="contained"
            color="secondary"
            fullWidth
            // 新規作成のときはtimestampの部分に__NEW__を設定して識別する
            onClick={() =>
              this.props.history.push(`/obsrec/kansatsukiroku/${this.props.match.params.koujibangou}/__NEW__`)} // todo
          >
            撮影する
          </Button>
        </Paper>
        <Paper
          style={styles.contentBase}
        >
          <Typography variant="h6">
            [観察記録]
          </Typography>
          <hr/>
          <List>
              {this.props.kansatsuKirokuObsrec.items.map((item, index) => {
                return (
                  <ListItem
                    button
                    divider
                    key={item.key}
                  >
                    <Grid container alignItems="center">
                      <Grid item sm={7} xs={12}>
                        <NavLink
                          key={`link_${index}`}
                          style={{textDecoration: 'none', color: 'unset'}}
                          to={`/obsrec/kansatsukiroku/${item.koujiBangou}/${item.key}`}
                        >
                          <ListItemText
                            primary={`観察年月日 : ${item.kansatsuDate ? moment(item.kansatsuDate, 'YYYY-MM-DD').format('YYYY年MM月DD日') : '無し'}`}
                            secondary={`測点No : ${item.sokutenNumber || '無し'} / 断面番号 : ${item.danmenNumber || '無し'} / 坑口からの距離 : ${item.kyori || '無し'}`}
                          />
                        </NavLink>
                      </Grid>
                      <Grid item sm={2} xs={12}>
                        <Typography variant="caption" style={{ color: 'rgba(0,0,0,0.54)', width: '110px'}}>
                          作成：
                          {(item.createdAt) ? moment(item.createdAt).format('MM/DD HH:mm') : '-'} <br/>
                          更新：
                          {(item.lastModifiedAt) ? moment(item.lastModifiedAt).format('MM/DD HH:mm') : '-'}
                        </Typography>
                      </Grid>
                      <Grid item sm={3} xs={12}>
                        <div>
                          <Button
                            size="small"
                            variant="contained"
                            color="secondary"
                            style={{ margin: '5px' }}
                            disabled={item.downloadFileStatus !== 'created'}
                            onClick={() => {
                              download(item.downloadFileBucket, item.downloadFileKey);
                            }}
                          >
                            ダウンロード
                          </Button>
                        </div>
                        <div>
                          {
                            (item.downloadFileCreationDatetime)
                             ? (
                              <Typography variant="caption" style={{ color: 'rgba(0,0,0,0.54)'}}>
                                {moment(item.downloadFileCreationDatetime).format('MM/DD HH:mm')}に作成
                              </Typography>
                             )
                             : (null)
                          }
                        </div>
                      </Grid>                    </Grid>
                  </ListItem>
              );
              })}
          </List>
          {
            this.props.kansatsuKirokuObsrec.items.length === 0
              ? (<Typography variant="body2">データはありません</Typography>)
              : (<div style={{ width: '100%', textAlign: 'right' }}>
                <Button
                  variant="outlined"
                  onClick={() => {
                    this.props.history.push(`/fullarchivedownloadObsrec/${site.koujiBangou}`);
                  }}
                >
                  一括ダウンロードページへ
                </Button>
              </div>)
          }
        </Paper>
        <CloseBackButton history={this.props.history} />
      </Paper>
    </div>
    );
  }
}

function mapDispatchToProps(dispatch: Dispatch<Action<any>>) {
  return {
    fetch: ({ koujiBangou }) => {
      kansatsuKirokuObsrecOperations.fetch({ koujiBangou })(dispatch);
    },
  };
}

function mapStateToProps(appState: IAppState) {
  return {
    user: appState.user,
    sites: appState.siteInfoListObsrec,
    kansatsuKirokuObsrec: appState.kansatsuKirokuObsrec,
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(KansatuKirokuObsrecListPage);



// WEBPACK FOOTER //
// ./src/components/obsrec/KansatuKirokuObsrecListPage.tsx